import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { I18nProvider } from './app/i18n/i18n-provider';
import { SessionProvider } from './app/session/session-provider';
import { ApiProvider } from './app/api/api-provider';
import { router } from './app/router';
import { EventUiProvider } from './app/components/event-ui-provider';
import { PwaProvider } from './app/pwa/pwa-provider';
import '@voldzi/stratos-ui/tokens.css';
import './app/styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('#root element missing from index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <I18nProvider>
      <PwaProvider>
        <EventUiProvider>
          <ApiProvider>
            <SessionProvider>
              <RouterProvider router={router} />
            </SessionProvider>
          </ApiProvider>
        </EventUiProvider>
      </PwaProvider>
    </I18nProvider>
  </React.StrictMode>,
);
